import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord, BrandModel } from '@common/models';

export interface ISalesPackagePriceRuleBrandModel extends IModel {
  salesPackagePriceRuleBrandId: number;
  salesPackagePriceRuleId: number;
  brandId: number;
  brand: BrandModel;
}

export class SalesPackagePriceRuleBrandModel
  extends Model
  implements ModelRecord<ISalesPackagePriceRuleBrandModel>
{
  salesPackagePriceRuleBrandId: number;
  salesPackagePriceRuleId: number;
  brandId: number;
  brand: BrandModel;
  constructor(params?: Partial<ISalesPackagePriceRuleBrandModel>) {
    super(params);
    this.salesPackagePriceRuleBrandId = defaultTo(
      params?.salesPackagePriceRuleBrandId,
      0,
    );
    this.salesPackagePriceRuleId = defaultTo(
      params?.salesPackagePriceRuleId,
      0,
    );
    this.brandId = defaultTo(params?.brandId, 0);
    this.brand = params?.brand
      ? new BrandModel(params.brand)
      : new BrandModel();
  }
}
